import { hereticAppUrl } from "../../lib/heretic.js";

export type ProductId = "tgpe_desktop" | "watchword" | "lazyshot";

export interface ProductCard {
  id: ProductId;
  /** i18n key for product name (under `cross_promo.products.<id>.title`). */
  titleKey: string;
  /** i18n key for the value-prop blurb. */
  blurbKey: string;
  /** i18n key for the CTA label. */
  ctaKey: string;
  /** Single-glyph fallback icon. */
  icon: string;
  /** Optional image URL — when set, components render this instead of the glyph. */
  iconUrl?: string;
  /** Resolves the destination URL at click time. Locale-aware via i18n. */
  url: () => string;
}

export const PRODUCTS: ProductCard[] = [
  {
    id: "tgpe_desktop",
    titleKey: "cross_promo.products.tgpe_desktop.title",
    blurbKey: "cross_promo.products.tgpe_desktop.blurb",
    ctaKey: "cross_promo.products.tgpe_desktop.cta",
    icon: "✦",
    iconUrl: "/icons/tgpe-desktop.png",
    url: () => hereticAppUrl(),
  },
  {
    id: "watchword",
    titleKey: "cross_promo.products.watchword.title",
    blurbKey: "cross_promo.products.watchword.blurb",
    ctaKey: "cross_promo.products.watchword.cta",
    icon: "🔮",
    iconUrl: "/icons/watchword.svg",
    url: () => "https://giglabo.com/watchword",
  },
  {
    id: "lazyshot",
    titleKey: "cross_promo.products.lazyshot.title",
    blurbKey: "cross_promo.products.lazyshot.blurb",
    ctaKey: "cross_promo.products.lazyshot.cta",
    icon: "⚡",
    iconUrl: "/icons/lazy-shot.svg",
    url: () => hereticAppUrl("heretic-lazy-shot"),
  },
];
